// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__43FYr","rootSuccess":"CompleteLink_rootSuccess__2d7Rm","rootFailure":"CompleteLink_rootFailure__3Gpv9","isDisabled":"CompleteLink_isDisabled__2FmI3"};